import * as React from 'react'

import { ErrorBoundary } from '@/modules/shared/components/ErrorBoundary'
import { TimesheetAdditionalPageContent } from './TimesheetAdditionalPageContent'
import { ErrorFallback } from '@/modules/shared/components/ErrorFallback'
import { RouteComponentProps } from '@/app/navigation/withRouter'

export const TimesheetAdditionalPage = (props: RouteComponentProps<{ companyId: string }>) => {
  return  (
    <ErrorBoundary fallback={(e) => <ErrorFallback error={e.error} onRetry={e.reset} />}>
      <TimesheetAdditionalPageContent {...props} />
    </ErrorBoundary>
  )
}
